import { approvalsCreditNoteScreen, approvalsHubScreen, approvalsOperatorsScreen, loadApprovalsGuides } from '@/modules/approvals/route';
import {
  bankAccountProductDetailScreen,
  bankAccountProductListScreen,
  loadBankAccountProductGuides,
} from '@/modules/bank-account-product/route';
import { billingProductScreen, loadBillingProductGuides } from '@/modules/billing-product/route';
import {
  billingSettingListScreen,
  loadBillingSettingGuides,
} from '@/modules/billing-setting/route';
import {
  communicationSettingListScreen,
  loadCommunicationSettingGuides,
} from '@/modules/communication-setting/route';
import {
  creditNoteDetailScreen,
  creditNoteListScreen,
  creditNoteNewScreen,
  loadCreditNoteGuides,
} from '@/modules/credit-note/route';
import {
  chatbotDetailScreen,
  chatbotListScreen,
  chatbotReportScreen,
  loadChatbotGuides,
} from '@/modules/chatbot/route';
import { dashboardScreen, loadDashboardGuides } from '@/modules/dashboard/route';
import {
  authorizationsScreen,
  createTestEmployeeScreen,
  deleteAuthorizationScreen,
  loadDataprevEmployeeGuides,
  warrantyExecutionScreen,
} from '@/modules/dataprev-employee/route';
import { fundDetailScreen, fundListScreen, loadFundGuides } from '@/modules/fund/route';
import {
  loadPayrollAgreementGuides,
  payrollAgreementDetailScreen,
  payrollAgreementListScreen,
} from '@/modules/payroll-agreement/route';
import { loadPixMedGuides, pixMedAdminScreen } from '@/modules/pix-med/route';
import {
  loadProductDebitAccountGuides,
  productDebitAccountScreen,
} from '@/modules/product-debit-account/route';
import {
  loadTenantRequestGuides,
  tenantRequestDetailScreen,
  tenantRequestListScreen,
} from '@/modules/tenant-request/route';
import {
  creditProductDetailScreen,
  creditProductListScreen,
  loadCreditProductGuides,
} from '@/modules/credit-product/route';
import {
  loadProductRulesGuides,
  productRuleDetailScreen,
  productRulesListScreen,
  ruleProductsScreen,
} from '@/modules/credit-product-rules/route';
import {
  dynamicRuleDetailScreen,
  dynamicRulesListScreen,
  dynamicRulesSimulateScreen,
  loadDynamicRulesGuides,
} from '@/modules/dynamic-rules/route';
import {
  loadSystemApplicationGuides,
  systemApplicationDetailScreen,
  systemApplicationListScreen,
} from '@/modules/system-application/route';
import {
  loadTenantPermissionResourceGuides,
  tenantPermissionResourceFormScreen,
  tenantPermissionResourceListScreen,
} from '@/modules/tenant-permission-resource/route';
import {
  effectivePermissionsScreen,
  loadProfileGuides,
  notificationSettingsScreen,
  profileScreen,
} from '@/modules/profile/route';
import { loadReconciliationGuides, reconciliationScreen } from '@/modules/reconciliation/route';
import { loadSpiGuides, spiConsultScreen, spiPanelScreen } from '@/modules/spi/route';
import { loadUserGuides, userDetailScreen, userListScreen } from '@/modules/user/route';
import {
  loadUserGroupGuides,
  userGroupDetailScreen,
  userGroupListScreen,
} from '@/modules/user-group/route';
import {
  legalPersonDetailScreen,
  legalPersonListScreen,
  legalPersonPendingScreen,
  loadPersonGuides,
  naturalPersonDetailScreen,
  naturalPersonListScreen,
  naturalPersonPendingScreen,
} from '@/modules/person/route';
import {
  loadWalletGuides,
  walletConfirmationLinesScreen,
  walletDetailScreen,
  walletInstructionLinesScreen,
  walletListScreen,
} from '@/modules/wallet/route';
import {
  creditNoteDeletedScreen,
  loadCreditNoteDeletedGuides,
} from '@/modules/credit-note-deleted/route';
import {
  batchAssignmentDetailScreen,
  batchAssignmentListScreen,
  batchAssignmentNewScreen,
  loadBatchAssignmentGuides,
} from '@/modules/batch-assignment/route';
import {
  bankAccountRequestDetailScreen,
  bankAccountRequestListScreen,
  loadBankAccountRequestGuides,
} from '@/modules/bank-account-request/route';
import {
  automaticSplitFormScreen,
  automaticSplitListScreen,
  automaticSplitPlanScreen,
  loadAutomaticSplitGuides,
} from '@/modules/automatic-split/route';
import {
  ACCOUNT_MED_SCREENS,
  bankAccountAutomaticPixActiveScreen,
  bankAccountAutomaticPixHistoryScreen,
  bankAccountAutomaticPixPaidScreen,
  bankAccountAutomaticPixPendingScreen,
  bankAccountAutomaticPixScheduledScreen,
  bankAccountAutomaticPixScreen,
  bankAccountDetailScreen,
  bankAccountListScreen,
  bankAccountPixKeysScreen,
  loadBankAccountGuides,
  transitoryAccountScreen,
} from '@/modules/bank-account/route';
import {
  dimensaSubmissionScreen,
  loadDimensaSubmissionGuides,
} from '@/modules/dimensa-submission/route';
import { discountScreen, loadDiscountGuides } from '@/modules/discount/route';
import {
  loadSimulationGuides,
  simulationCarEquityScreen,
  simulationHireScreen,
  simulationInssPayrollNewScreen,
  simulationInssPayrollScreen,
  simulationPersonalCreditScreen,
  simulationPrivateCdcPayrollScreen,
  simulationPrivatePayrollNewScreen,
  simulationPrivatePayrollScreen,
  simulationPublicPayrollNewScreen,
  simulationPublicPayrollScreen,
  simulationSimulateScreen,
  simulationVehicleFinancingScreen,
  simulationVehicleScreen,
  simulationPublicRefinancingScreen,
  simulationPrivateRefinancingScreen,
  simulationInssRefinancingScreen,
  simulationDebtPurchaseScreen,
} from '@/modules/simulation/route';
import { createScreenRegistry } from '@/shared/screen';
import { billingDetailScreen, billingListScreen, loadBillingGuides } from '@/modules/billing/route';
import { installmentDetailScreen, installmentListScreen, loadInstallmentGuides } from '@/modules/installment/route';
import {
  collectionAgreementScreen,
  collectionAgreementsScreen,
  collectionDashboardScreen,
  collectionDebtorScreen,
  collectionQueueScreen,
  loadCollectionGuides,
} from '@/modules/collection/route';
import { loadWalletDashboardGuides, walletDashboardScreen } from '@/modules/wallet-dashboard/route';
import {
  conciliationDetailScreen,
  conciliationHubScreen,
  conciliationListScreen,
  conciliationNewScreen,
  loadConciliationGuides,
  suspenseAccountDetailScreen,
  suspenseAccountListScreen,
} from '@/modules/conciliation/route';

import { homeScreen } from './home.screen';
import { underConstructionScreen } from './under-construction.screen';

/** Guia de cada tela para o Luy (U46), carregado sob demanda. Tela sem guia é dívida (`GUIDE_DEBT`). */
const guides = {
  [underConstructionScreen.id]: () => import('./under-construction.guide'),
  [homeScreen.id]: () => import('./home.guide'),
  ...Object.fromEntries(ACCOUNT_MED_SCREENS.map((s) => [s.id, loadBankAccountGuides])),
  [creditNoteDeletedScreen.id]: loadCreditNoteDeletedGuides,
  [billingListScreen.id]: loadBillingGuides,
  [billingDetailScreen.id]: loadBillingGuides,
  [installmentListScreen.id]: loadInstallmentGuides,
  [installmentDetailScreen.id]: loadInstallmentGuides,
  [creditNoteListScreen.id]: loadCreditNoteGuides,
  [creditNoteDetailScreen.id]: loadCreditNoteGuides,
  [creditNoteNewScreen.id]: loadCreditNoteGuides,
  [naturalPersonListScreen.id]: loadPersonGuides,
  [naturalPersonPendingScreen.id]: loadPersonGuides,
  [naturalPersonDetailScreen.id]: loadPersonGuides,
  [legalPersonListScreen.id]: loadPersonGuides,
  [legalPersonPendingScreen.id]: loadPersonGuides,
  [legalPersonDetailScreen.id]: loadPersonGuides,
  [walletListScreen.id]: loadWalletGuides,
  [walletDetailScreen.id]: loadWalletGuides,
  [walletInstructionLinesScreen.id]: loadWalletGuides,
  [walletConfirmationLinesScreen.id]: loadWalletGuides,
  [fundListScreen.id]: loadFundGuides,
  [fundDetailScreen.id]: loadFundGuides,
  [creditProductListScreen.id]: loadCreditProductGuides,
  [creditProductDetailScreen.id]: loadCreditProductGuides,
  [productRulesListScreen.id]: loadProductRulesGuides,
  [productRuleDetailScreen.id]: loadProductRulesGuides,
  [ruleProductsScreen.id]: loadProductRulesGuides,
  [dynamicRulesListScreen.id]: loadDynamicRulesGuides,
  [dynamicRuleDetailScreen.id]: loadDynamicRulesGuides,
  [dynamicRulesSimulateScreen.id]: loadDynamicRulesGuides,
  [bankAccountProductListScreen.id]: loadBankAccountProductGuides,
  [bankAccountProductDetailScreen.id]: loadBankAccountProductGuides,
  [payrollAgreementListScreen.id]: loadPayrollAgreementGuides,
  [payrollAgreementDetailScreen.id]: loadPayrollAgreementGuides,
  [tenantRequestListScreen.id]: loadTenantRequestGuides,
  [tenantRequestDetailScreen.id]: loadTenantRequestGuides,
  [billingSettingListScreen.id]: loadBillingSettingGuides,
  [communicationSettingListScreen.id]: loadCommunicationSettingGuides,
  [billingProductScreen.id]: loadBillingProductGuides,
  [authorizationsScreen.id]: loadDataprevEmployeeGuides,
  [createTestEmployeeScreen.id]: loadDataprevEmployeeGuides,
  [deleteAuthorizationScreen.id]: loadDataprevEmployeeGuides,
  [warrantyExecutionScreen.id]: loadDataprevEmployeeGuides,
  [pixMedAdminScreen.id]: loadPixMedGuides,
  [productDebitAccountScreen.id]: loadProductDebitAccountGuides,
  [reconciliationScreen.id]: loadReconciliationGuides,
  [profileScreen.id]: loadProfileGuides,
  [notificationSettingsScreen.id]: loadProfileGuides,
  [effectivePermissionsScreen.id]: loadProfileGuides,
  [userListScreen.id]: loadUserGuides,
  [userDetailScreen.id]: loadUserGuides,
  [userGroupListScreen.id]: loadUserGroupGuides,
  [userGroupDetailScreen.id]: loadUserGroupGuides,
  [systemApplicationListScreen.id]: loadSystemApplicationGuides,
  [systemApplicationDetailScreen.id]: loadSystemApplicationGuides,
  [tenantPermissionResourceListScreen.id]: loadTenantPermissionResourceGuides,
  [tenantPermissionResourceFormScreen.id]: loadTenantPermissionResourceGuides,
  [batchAssignmentListScreen.id]: loadBatchAssignmentGuides,
  [batchAssignmentNewScreen.id]: loadBatchAssignmentGuides,
  [batchAssignmentDetailScreen.id]: loadBatchAssignmentGuides,
  [dimensaSubmissionScreen.id]: loadDimensaSubmissionGuides,
  [discountScreen.id]: loadDiscountGuides,
  [bankAccountListScreen.id]: loadBankAccountGuides,
  [bankAccountDetailScreen.id]: loadBankAccountGuides,
  [transitoryAccountScreen.id]: loadBankAccountGuides,
  [bankAccountPixKeysScreen.id]: loadBankAccountGuides,
  [bankAccountAutomaticPixScreen.id]: loadBankAccountGuides,
  [bankAccountAutomaticPixHistoryScreen.id]: loadBankAccountGuides,
  [bankAccountAutomaticPixPendingScreen.id]: loadBankAccountGuides,
  [bankAccountAutomaticPixActiveScreen.id]: loadBankAccountGuides,
  [bankAccountAutomaticPixScheduledScreen.id]: loadBankAccountGuides,
  [bankAccountAutomaticPixPaidScreen.id]: loadBankAccountGuides,
  [bankAccountRequestListScreen.id]: loadBankAccountRequestGuides,
  [bankAccountRequestDetailScreen.id]: loadBankAccountRequestGuides,
  [automaticSplitListScreen.id]: loadAutomaticSplitGuides,
  [automaticSplitPlanScreen.id]: loadAutomaticSplitGuides,
  [automaticSplitFormScreen.id]: loadAutomaticSplitGuides,
  [spiPanelScreen.id]: loadSpiGuides,
  [spiConsultScreen.id]: loadSpiGuides,
  [simulationSimulateScreen.id]: loadSimulationGuides,
  [simulationHireScreen.id]: loadSimulationGuides,
  [simulationPersonalCreditScreen.id]: loadSimulationGuides,
  [simulationVehicleScreen.id]: loadSimulationGuides,
  [simulationCarEquityScreen.id]: loadSimulationGuides,
  [simulationVehicleFinancingScreen.id]: loadSimulationGuides,
  [simulationPublicRefinancingScreen.id]: loadSimulationGuides,
  [simulationPrivateRefinancingScreen.id]: loadSimulationGuides,
  [simulationInssRefinancingScreen.id]: loadSimulationGuides,
  [simulationDebtPurchaseScreen.id]: loadSimulationGuides,
  [simulationPublicPayrollScreen.id]: loadSimulationGuides,
  [simulationPublicPayrollNewScreen.id]: loadSimulationGuides,
  [simulationInssPayrollScreen.id]: loadSimulationGuides,
  [simulationInssPayrollNewScreen.id]: loadSimulationGuides,
  [simulationPrivatePayrollScreen.id]: loadSimulationGuides,
  [simulationPrivatePayrollNewScreen.id]: loadSimulationGuides,
  [simulationPrivateCdcPayrollScreen.id]: loadSimulationGuides,
  [dashboardScreen.id]: loadDashboardGuides,
  [walletDashboardScreen.id]: loadWalletDashboardGuides,
  [chatbotListScreen.id]: loadChatbotGuides,
  [chatbotReportScreen.id]: loadChatbotGuides,
  [chatbotDetailScreen.id]: loadChatbotGuides,
  [collectionDashboardScreen.id]: loadCollectionGuides,
  [collectionQueueScreen.id]: loadCollectionGuides,
  [collectionDebtorScreen.id]: loadCollectionGuides,
  [collectionAgreementsScreen.id]: loadCollectionGuides,
  [collectionAgreementScreen.id]: loadCollectionGuides,
  [conciliationHubScreen.id]: loadConciliationGuides,
  [conciliationListScreen.id]: loadConciliationGuides,
  [conciliationNewScreen.id]: loadConciliationGuides,
  [conciliationDetailScreen.id]: loadConciliationGuides,
  [suspenseAccountListScreen.id]: loadConciliationGuides,
  [suspenseAccountDetailScreen.id]: loadConciliationGuides,
  [approvalsHubScreen.id]: loadApprovalsGuides,
  [approvalsOperatorsScreen.id]: loadApprovalsGuides,
  [approvalsCreditNoteScreen.id]: loadApprovalsGuides,
};

// Registro de telas (U23): o menu vira link interno quando o `path` do manifesto casa com o do legado.
export const screens = createScreenRegistry(
  [
    homeScreen,
    underConstructionScreen,
    ...ACCOUNT_MED_SCREENS,
    bankAccountProductListScreen,
    bankAccountProductDetailScreen,
    billingProductScreen,
    billingListScreen,
    billingDetailScreen,
    installmentListScreen,
    installmentDetailScreen,
    billingSettingListScreen,
    communicationSettingListScreen,
    creditNoteListScreen,
    creditNoteDetailScreen,
    creditNoteDeletedScreen,
    bankAccountRequestListScreen,
    bankAccountRequestDetailScreen,
    batchAssignmentListScreen,
    batchAssignmentNewScreen,
    batchAssignmentDetailScreen,
    bankAccountListScreen,
    bankAccountDetailScreen,
    transitoryAccountScreen,
    bankAccountPixKeysScreen,
    bankAccountAutomaticPixScreen,
    bankAccountAutomaticPixHistoryScreen,
    bankAccountAutomaticPixPendingScreen,
    bankAccountAutomaticPixActiveScreen,
    bankAccountAutomaticPixScheduledScreen,
    bankAccountAutomaticPixPaidScreen,
    dimensaSubmissionScreen,
    discountScreen,
    simulationSimulateScreen,
    simulationHireScreen,
    simulationPersonalCreditScreen,
    simulationVehicleScreen,
    simulationCarEquityScreen,
    simulationVehicleFinancingScreen,
    simulationPublicPayrollScreen,
    simulationPublicPayrollNewScreen,
    simulationInssPayrollScreen,
    simulationInssPayrollNewScreen,
    simulationPrivatePayrollScreen,
    simulationPrivatePayrollNewScreen,
    simulationPrivateCdcPayrollScreen,
    simulationPublicRefinancingScreen,
    simulationPrivateRefinancingScreen,
    simulationInssRefinancingScreen,
    simulationDebtPurchaseScreen,
    authorizationsScreen,
    createTestEmployeeScreen,
    deleteAuthorizationScreen,
    warrantyExecutionScreen,
    fundListScreen,
    fundDetailScreen,
    payrollAgreementListScreen,
    payrollAgreementDetailScreen,
    pixMedAdminScreen,
    productDebitAccountScreen,
    tenantRequestListScreen,
    tenantRequestDetailScreen,
    creditProductListScreen,
    creditProductDetailScreen,
    productRulesListScreen,
    productRuleDetailScreen,
    ruleProductsScreen,
    dynamicRulesListScreen,
    dynamicRuleDetailScreen,
    dynamicRulesSimulateScreen,
    systemApplicationListScreen,
    systemApplicationDetailScreen,
    tenantPermissionResourceListScreen,
    tenantPermissionResourceFormScreen,
    userListScreen,
    userDetailScreen,
    userGroupListScreen,
    userGroupDetailScreen,
    reconciliationScreen,
    profileScreen,
    notificationSettingsScreen,
    effectivePermissionsScreen,
    naturalPersonListScreen,
    naturalPersonPendingScreen,
    naturalPersonDetailScreen,
    legalPersonListScreen,
    legalPersonPendingScreen,
    legalPersonDetailScreen,
    walletListScreen,
    walletDetailScreen,
    walletInstructionLinesScreen,
    walletConfirmationLinesScreen,
    automaticSplitListScreen,
    automaticSplitPlanScreen,
    automaticSplitFormScreen,
    creditNoteNewScreen,
    spiPanelScreen,
    spiConsultScreen,
    dashboardScreen,
    walletDashboardScreen,
    chatbotListScreen,
    chatbotReportScreen,
    chatbotDetailScreen,
    collectionDashboardScreen,
    collectionQueueScreen,
    collectionDebtorScreen,
    collectionAgreementsScreen,
    collectionAgreementScreen,
    conciliationHubScreen,
    conciliationListScreen,
    conciliationNewScreen,
    // Antes do detalhe: o `byPath` devolve a primeira que casa, e `$conciliationId` casaria com "bolsao".
    suspenseAccountListScreen,
    suspenseAccountDetailScreen,
    conciliationDetailScreen,
    approvalsHubScreen,
    approvalsOperatorsScreen,
    approvalsCreditNoteScreen,
  ],
  { guides },
);
